<template>
	<div v-if="currentEnvironment" class="env-float-container">
		<div
			class="env-button-group"
			ref="envGroupRef"
			@touchstart="onTouchStart"
			@touchmove="onTouchMove"
			@touchend="onTouchEnd"
		>
			<button class="env-button env-switch-btn" @click="switchToStandardEnv" title="切换到标准环境">
				切换标准环境
			</button>
			<div class="env-indicator">当前环境：{{ currentEnvironment }}</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
	currentEnvironment: {
		type: String,
		default: ''
	}
});

const emit = defineEmits(['switch']);
const switchToStandardEnv = () => {
	// 只有非拖拽的情况下才触发点击
	if (!isDragging.value) {
		emit('switch');
	}
};

const envGroupRef = ref(null);

// 拖拽相关状态
const startX = ref(0);
const startY = ref(0);
const deltaX = ref(0);
const deltaY = ref(0);
const translateX = ref(0);
const translateY = ref(0);
const isDragging = ref(false);

const onTouchStart = e => {
	const touch = e.touches[0];
	startX.value = touch.clientX;
	startY.value = touch.clientY;
	isDragging.value = false;
};

const onTouchMove = e => {
	const touch = e.touches[0];
	deltaX.value = touch.clientX - startX.value;
	deltaY.value = touch.clientY - startY.value;

	// 判断是否进入拖拽（避免轻微滑动干扰点击）
	if (Math.abs(deltaX.value) > 5 || Math.abs(deltaY.value) > 5) {
		isDragging.value = true;
	}

	if (isDragging.value) {
		envGroupRef.value.style.transform = `translate(${translateX.value + deltaX.value}px, ${
			translateY.value + deltaY.value
		}px)`;
	}
};

const onTouchEnd = () => {
	if (isDragging.value) {
		translateX.value += deltaX.value;
		translateY.value += deltaY.value;
		deltaX.value = 0;
		deltaY.value = 0;
	}
};
</script>

<style scoped>
.env-float-container {
	position: fixed;
	bottom: 20px;
	left: 20px;
	z-index: 9999;
}

.env-button-group {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.env-button {
	padding: 8px 16px;
	border: 1px solid rgba(74, 144, 226, 0.4);
	border-radius: 6px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	transition: all 0.2s ease;
	white-space: nowrap;
	background: rgba(74, 144, 226, 0.1);
	color: #4a90e2;
	backdrop-filter: blur(8px);
}

.env-switch-btn:hover {
	background: rgba(74, 144, 226, 0.2);
	border-color: rgba(74, 144, 226, 0.6);
	transform: translateY(-1px);
	box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);
}

.env-switch-btn:active {
	transform: translateY(0);
	background: rgba(74, 144, 226, 0.15);
}

.env-indicator {
	background: rgba(255, 159, 64, 0.1);
	color: #e67e22;
	padding: 8px 14px;
	border: 1px solid rgba(255, 159, 64, 0.3);
	border-radius: 6px;
	font-size: 11px;
	font-weight: 500;
	user-select: none;
	white-space: nowrap;
	backdrop-filter: blur(8px);
}
</style>
